import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import styled from 'styled-components';

const StyledFormGroup = styled(Form.Group)`
  margin-bottom: -1rem;
`;

const StyledFormLabel = styled(Form.Label)`
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
  width: 100%;
`;

const StyledFormSelect = styled(Form.Select)`
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  padding: 0.375rem 2.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  
  &:focus {
    border-color: #86b7fe;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  }
`;

const LoadingSpinner = styled.div`
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 0.5rem;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const TradeDropdown = ({ selectedTrade, onTradeChange, disabled = false, loading = false }) => {
  const [isUpdating, setIsUpdating] = useState(false);

  const handleTradeChange = async (e) => {
    const newValue = e.target.value;
    setIsUpdating(true);
    
    try {
      await onTradeChange(newValue);
    } catch (error) {
      // Error handling is done in the parent component
      console.error('Trade update failed:', error);
    } finally {
      setIsUpdating(false);
    }
  };

  const isDisabled = disabled || loading || isUpdating;
  const showLoading = loading || isUpdating;

  return (
    <StyledFormGroup>
      <StyledFormLabel>
        Select Trade
        {showLoading && <LoadingSpinner />}
      </StyledFormLabel>
      <StyledFormSelect
        value={selectedTrade || 'cleaning'}
        onChange={handleTradeChange}
        disabled={isDisabled}
      >
        <option value="cleaning">Cleaning</option>
        <option value="painting">Painting</option>
      </StyledFormSelect>
    </StyledFormGroup>
  );
};

export default TradeDropdown; 